export class ProductsRequest {
    public digitalClassCode: string;
    public stateId: string;
    public annualRevenue: string;
    public isSciExcluded: boolean;
    public wsgClassId: string;
    public isInsideSales?: boolean;
}
